<script lang="ts">
  import { Table } from 'sveltestrap'
  import { getUserDevices } from 'src/components/cabinet/#services/getUserProfile'

  export let userId;

  let userDevicesPromise
  $:userDevicesPromise = getUserDevices.request({data:{userId}})
</script>

{#await userDevicesPromise}
  Loading...
{:then data}
<div class="profile-devices">
    <Table responsive>
          <thead>
              <tr>
                  <th>Game</th>
                  <th>DeviceID</th>
              </tr>
          </thead>
          <tbody>
              {#each data.devices as device}
                <tr>
                    <td>{device.game}</td>
                    <td>{device.deviceId}</td>
                </tr>
              {/each}
          </tbody>
    </Table>
</div>
{:catch error}
  {error}
{/await}

<style>
  .profile-devices :global(table) {
      width: auto;
  }

  .profile-devices :global(td strong) {
      font-weight: 500;
  }
</style>
